document.addEventListener('DOMContentLoaded', function () {
    const reviewsWrapper = document.querySelector('.reviews-wrapper');
    const contentArrows = document.querySelector('.arrows-controls');
    const prevButton = document.querySelector('.prev');
    const nextButton = document.querySelector('.next');
    const reviewContainers = document.querySelectorAll('.review-container');
    const reviewsScrollbar = document.querySelector('.reviews-scrollbar');
    const scrollbarDrag = document.querySelector('.reviews-scrollbar-drag');
    let currentIndex = 0;

    function updateCarousel() {
        const totalReviews = reviewContainers.length;
        const containerWidth = reviewContainers[0].offsetWidth;
        const wrapperWidth = reviewsWrapper.offsetWidth;
        const visibleReviews = Math.floor(wrapperWidth / containerWidth);

        const offset = -currentIndex * (containerWidth + 24); 
        const scrollbarWidth = reviewsScrollbar.offsetWidth;
        const dragWidth = (visibleReviews / totalReviews) * scrollbarWidth;
        const dragOffset = (currentIndex / (totalReviews-visibleReviews)) * (scrollbarWidth - dragWidth);

        
        reviewsWrapper.style.transform = `translateX(${offset}px)`;
        scrollbarDrag.style.width = `${dragWidth}px`;
        scrollbarDrag.style.transform = `translateX(${dragOffset}px)`;

        if (totalReviews <= visibleReviews) {
            if (window.innerWidth > 999 ) {
                contentArrows.style.display = 'none';
            }
        } else {
            contentArrows.style.display = 'flex';
            if (currentIndex === 0) {
                prevButton.classList.add('disabled');
            } else {
                prevButton.classList.remove('disabled');
            }

            if (currentIndex >= totalReviews - visibleReviews) {
                nextButton.classList.add('disabled');
            } else {
                nextButton.classList.remove('disabled');
            }
        }
    }

    function goToNextReview() {
        const totalReviews = reviewContainers.length;
        const containerWidth = reviewContainers[0].offsetWidth;
        const wrapperWidth = reviewsWrapper.offsetWidth;
        const visibleReviews = Math.floor(wrapperWidth / containerWidth);

        if (currentIndex < totalReviews - visibleReviews) {
            currentIndex++;
            updateCarousel();
        }
    }

    function goToPrevReview() {
        if (currentIndex > 0) {
            currentIndex--;
            updateCarousel();
        }
    }
    nextButton.addEventListener('click', goToNextReview);
    prevButton.addEventListener('click', goToPrevReview);
    window.addEventListener('resize', updateCarousel);

    updateCarousel();
});